<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <b-row class="align-items-center">
          <b-col>
            <h3 class="m-0">Gerenciamento de Usuários</h3>
          </b-col>
          <b-col class="text-right">
            <b-button variant="secondary" v-b-modal.mdlFiltros class="mr-2">
              Filtros
            </b-button>
            <b-button variant="primary" @click="novoUsuario"> Novo </b-button>
          </b-col>
        </b-row>
      </b-card-header>

      <b-card-body>
        <b-table
          :items="usuarios"
          :fields="fields"
          :busy="loading"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          no-local-sorting
          show-empty
          responsive
        >
          <template #empty>
            <div class="text-center">Nenhum usuário encontrado.</div>
          </template>

          <template v-slot:cell(roles)="data">
            {{ data.value.map((role) => role.name).join(", ") }}
          </template>

          <template v-slot:cell(unidade)="data">
            {{ data.value ? data.value.nome : "Sem unidade" }}
          </template>

          <template v-slot:cell(status)="data">
            <b-badge :variant="data.value === 'A' ? 'success' : 'danger'">{{
              data.value === "A" ? "Ativo" : "Inativo"
            }}</b-badge>
          </template>

          <template v-slot:cell(acao)="data">
            <b-dropdown
              variant="clean"
              size="small"
              toggle-class="btn-icon"
              no-caret
            >
              <template #button-content>
                <i class="fas fa-ellipsis-h"></i>
              </template>

              <b-dropdown-item @click="alterarSenhaUsuario(data.item)"
                >Alterar senha</b-dropdown-item
              >
              <b-dropdown-item @click="editarUsuario(data.item)"
                >Editar</b-dropdown-item
              >
              <b-dropdown-item @click="excluir(data.item.id)" variant="danger"
                >Excluir</b-dropdown-item
              >
            </b-dropdown>
          </template>
        </b-table>
      </b-card-body>

      <b-card-footer>
        <div
          class="d-flex justify-content-between align-items-center flex-wrap"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="m-0"
          ></b-pagination>

          <div class="d-flex align-items-center flex-wrap">
            <b-select v-model="perPage" size="sm" class="mr-4 per-page">
              <option
                v-for="option in [20, 50, 100]"
                :key="option"
                :value="option"
              >
                {{ option }}
              </option>
            </b-select>

            <span>
              Exibindo de {{ fromPage }} até {{ toPage }} de
              {{ totalRows }} registros.
            </span>
          </div>
        </div>
      </b-card-footer>
    </b-card>

    <b-modal
      id="mdlFiltros"
      ref="mdlFiltros"
      title="Filtros"
      ok-title="Filtrar"
      @ok="getUsuarios"
      cancel-title="Cancelar"
    >
      <b-row>
        <b-col cols="6">
          <b-form-group label="Nome:">
            <b-form-input v-model="filtros.nome" size="sm"></b-form-input>
          </b-form-group>
        </b-col>

        <b-col cols="6">
          <b-form-group label="Login:">
            <b-form-input v-model="filtros.login" size="sm"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6">
          <b-form-group label="Perfil:">
            <b-form-select
              v-model="filtros.funcao"
              :options="funcoes"
              value-field="id"
              text-field="name"
              size="sm"
            >
              <template #first>
                <b-form-select-option value="">Todos</b-form-select-option>
              </template>
            </b-form-select>
          </b-form-group>
        </b-col>

        <b-col cols="6">
          <b-form-group label="Unidade:">
            <b-form-select
              v-model="filtros.unidade"
              :options="unidades"
              value-field="id"
              text-field="nome"
              size="sm"
            >
              <template #first>
                <b-form-select-option value="">Todas</b-form-select-option>
              </template>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>

    <usuario-formulario
      ref="mdlUsuarioFormulario"
      :funcoes="funcoes"
      :unidades="unidades"
      @atualizar="getUsuarios"
    ></usuario-formulario>

    <usuario-alterar-senha ref="mdlUsuarioAlterarSenha"></usuario-alterar-senha>
  </div>
</template>

<script>
import UsuarioService from "@/core/services/usuario.service";
import UsuarioFormulario from "./UsuarioFormulario.vue";
import UsuarioAlterarSenha from "./UsuarioAlterarSenha.vue";
import Swal from "sweetalert2";

export default {
  name: "usuarios",

  components: {
    UsuarioFormulario,
    UsuarioAlterarSenha,
  },

  data() {
    return {
      usuarios: [],
      funcoes: [],
      unidades: [],
      loading: false,
      fields: [
        {
          key: "id",
          label: "ID",
          sortable: true,
          class: "text-center align-middle",
        },
        { key: "nome", label: "Nome", sortable: true, class: "align-middle" },
        {
          key: "usuario",
          label: "Login",
          sortable: true,
          class: "align-middle",
        },
        {
          key: "roles",
          label: "Perfil",
          sortable: true,
          class: "text-center align-middle",
        },
        {
          key: "unidade",
          label: "Unidade",
          sortable: true,
          class: "text-center align-middle",
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
          class: "text-center align-middle",
        },
        {
          key: "acao",
          label: "Ação",
          class: "text-center align-middle",
          sortable: false,
        },
      ],
      totalRows: 0,
      toPage: 0,
      fromPage: 0,
      currentPage: 1,
      perPage: 20,
      sortBy: "nome",
      sortDesc: false,
      filtros: {
        nome: "",
        login: "",
        funcao: "",
        unidade: "",
      },
    };
  },

  mounted() {
    this.getUsuarios();
  },

  methods: {
    async getUsuarios() {
      this.loading = true;

      await UsuarioService.getUsuarios({
        page: this.currentPage,
        perPage: this.perPage,
        sortBy: this.sortBy,
        sortDesc: this.sortDesc,
        ...Object.flatten(Object.filter(this.filtros), "filtros"),
      })
        .then(({ data }) => {
          this.usuarios = data.usuarios.data;
          this.totalRows = data.usuarios.total;
          this.toPage = data.usuarios.to;
          this.fromPage = data.usuarios.from;

          this.funcoes = data.funcoes;
          this.unidades = data.unidades;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    novoUsuario() {
      this.$refs.mdlUsuarioFormulario.exibirModal();
    },

    editarUsuario(usuario) {
      this.$refs.mdlUsuarioFormulario.exibirModal(usuario);
    },

    alterarSenhaUsuario(usuario) {
      this.$refs.mdlUsuarioAlterarSenha.exibirModal(usuario);
    },

    async excluir(id) {
      Swal.fire({
        title: "Atenção!",
        text: "Deseja realmente excluir este usuário?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then(async (result) => {
        if (result.value) {
          await UsuarioService.excluir(id).then(() => {
            Swal.fire("Sucesso!", "Usuário excluído com sucesso.", "success");
            this.getUsuarios();
          });
        }
      });
    },
  },

  watch: {
    currentPage() {
      this.getUsuarios();
    },

    perPage() {
      this.getUsuarios();
    },

    sortBy() {
      this.getUsuarios();
    },

    sortDesc() {
      this.getUsuarios();
    },
  },
};
</script>

<style scoped>
.per-page {
  height: calc(1.244em + 1.1rem + 2px) !important;
  width: 70px !important;
}
</style>
